import React from "react";
import { connect } from "react-redux";
import { Parse } from "parse";
import { Button, List, Modal } from "antd";
import { getNormalAvatar } from "../Constants/functions";

Parse.initialize("6cev9RMB5Q36eXubFhT27zEzDJ9ZfCDDBJv87csPPYE62tAvKD");

class ModalCorrespondents extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      members: []
    };
  }

  componentDidMount() {
    var ctx = this;
    var user = Parse.User.current();
    var query = new Parse.Query("Team");
    var team = user.get("team");
    var teamId = team.id;
    query.get(teamId).then(function(team) {
      var members = team.relation("members").query();
      members.notEqualTo("objectId", user.id)
      members.find().then(function(myMembers){
        var json2 = JSON.stringify(myMembers);
        var jsonConversations = JSON.parse(json2);
        ctx.setState({ members: jsonConversations });

      })
    });
  }

  showModal = () => {
    this.setState({
      visible: true
    });
  };

  handleCancel = e => {
    this.setState({
      visible: false
    });
  };

  selectRunner = item => {
    this.handleCancel();
    this.props.onClick(item);
  };

  render() {
    var members = this.state.members;
    return (
      <div>
        <Button style={{ fontSize: '14px', color: "#fff", backgroundColor: "#0000FE", borderColor:"#0000FE"}} onClick={this.showModal}>
          Envoyer un message
        </Button>

        <Modal
          visible={this.state.visible}
          onCancel={this.handleCancel}
          onOk={this.sendInvitations}
          okText="Chatter"
          footer={null}
          cancelText="Annuler"
        >
          <div>Avec quel Urban Fitteur de votre team voulez-vous chatter ?</div>
          <div>
            <List
              itemLayout="horizontal"
              dataSource={members}
              locale={{
                emptyText: "Tu n'as pas encore d'autres membres dans ta team."
              }}
              display="flex"
              pagination={{
                pageSize: 10,
                hideOnSinglePage: true
              }}
              renderItem={item => (
                <List.Item
                  key={item.id}
                  actions={[
                    <Button style={{ fontSize: '14px', color: "#fff", backgroundColor: "#0000FE", borderColor:"#0000FE"}}  onClick={() => this.selectRunner(item)}>
                      {" "}
                      Sélectionner{" "}
                    </Button>
                  ]}
                >
                  <List.Item.Meta
                    avatar={getNormalAvatar(item)}
                    title={item.nickName}
                  />
                </List.Item>
              )}
            />
          </div>
        </Modal>
      </div>
    );
  }
}



const mapStateToProps = globalReducers => globalReducers;
const SmartModalCorrespondents = connect(
  mapStateToProps,
  null
)(ModalCorrespondents);
export default SmartModalCorrespondents;
